import Plyr from 'plyr';

const plyrInstances = new Map();

const handlePlyrBlockClick = (event) => {
	const videoBlock = event.target.closest('.video-block.plyr-managed:not(.video-link):not(.marketing-list-access)');

	if (!videoBlock) {
		return;
	}

	event.preventDefault();

	const plyrEl = videoBlock.querySelector('.plyr-video');
	if (!plyrEl) {
		return;
	}

	// Hide the thumbnail overlay
	const info = videoBlock.querySelector('.video-info');
	const display = videoBlock.querySelector('.video-display');

	if (info) {
		info.classList.add('hidden');
	}

	if (display) {
		display.classList.remove('hidden');
	}

	// If already initialised, just play
	if (plyrInstances.has(plyrEl)) {
		plyrInstances.get(plyrEl).play();
		return;
	}

	// Initialise Plyr and autoplay
	const player = new Plyr(plyrEl, {
		controls: [
			'play-large',
			'play',
			'progress',
			'current-time',
			'mute',
			'volume',
			'captions',
			'fullscreen',
		],
		captions: {
			active: true,
			language: 'auto',
			update: true,
		},
		youtube: {
			cc_load_policy: 1,
		},
		autoplay: true,
	});

	plyrInstances.set(plyrEl, player);

	player.on('ready', () => {
		player.play();

		// Plyr's caption system doesn't hook into YouTube's native caption API.
		// cc_load_policy: 1 enables YouTube's native captions via the embed URL.
		// toggleCaptions(true) syncs Plyr's UI button to show as active (pressed).
		if (player.provider === 'youtube') {
			player.toggleCaptions(true);
		}
	});

	// Bridge Plyr's caption toggle events to YouTube's native caption API.
	// For Vimeo and HTML5, Plyr handles captions natively via captions: { active: true }.
	player.on('captionsenabled', () => {
		if (player.provider === 'youtube' && player.embed) {
			try {
				player.embed.loadModule('captions');
			} catch (e) {
				// Video may not have captions available
			}
		}
	});

	player.on('captionsdisabled', () => {
		if (player.provider === 'youtube' && player.embed) {
			try {
				player.embed.unloadModule('captions');
			} catch (e) {
				// Video may not have captions available
			}
		}
	});
};

if (document.querySelector('.video-block.plyr-managed')) {
	document.addEventListener('click', handlePlyrBlockClick, false);
}
